export const Modes = ['Romaji Only', 'Furigana', 'Romaji w/ Original']

export const ModePolicies = [
  ['romaji', 'spaced'],
  ['hiragana', 'furigana'],
  ['romaji', 'furigana'],
]
